import React, { useEffect, useRef } from 'react';
import { GiPositionMarker } from "react-icons/gi";
import { useLocation } from "react-router-dom";
import './pdfPage.css';
import { LocationIcon, RouteIcon } from '../../assets/icons/icons'
import { mapRenderer } from './utils/pdfHelpers';
import { getIntervalDistance } from '../../utils/getCoordPoints';
import CardComponent from './components/cardComponent/cardComponent';
import { FaPrint } from "react-icons/fa6";


export const PDFRouteLayout = () => {
  const location = useLocation();
  const { currentSequence, pathCoords } = location.state;
  const mapRef = useRef<HTMLDivElement>(null);

  const intervalDistance = getIntervalDistance(pathCoords);


  useEffect(() => { mapRenderer(mapRef, currentSequence, pathCoords) }, []);

  const delay = (ms: any) => new Promise(resolve => setTimeout(resolve, ms));

  async function handlePrint() {

    const printContent = document.querySelector('.ruta-container');
    const originalBody = document.body.innerHTML;

    if (printContent) {
      document.body.innerHTML = printContent.outerHTML;
      await delay(500);
      window.print();
      // document.body.innerHTML = originalBody;
      // window.location.reload();
    }
  };

  interface CardListProps {
    currentSequence: string[];
    intervalDistance: number[];
  }

  function CardList({ currentSequence, intervalDistance }: CardListProps) {
    return (
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {currentSequence.map((point, i) => {
          const isLast = i === currentSequence.length - 1;
          return (
            <CardComponent
              key={i}
              point={point}
              isLast={isLast}
              distanceToNext={intervalDistance[i]}
            />
          );
        })}
      </div>
    );
  }

  return (

    <body className="A4" >
      <div className="print-header">


        <button className="button-theme" onClick={handlePrint}>
          <FaPrint />
          Imprimir</button>
      </div>
      <div className="ruta-container">
        <div className="black-background-container">
          <div className="ruta-header">
            <div className="ruta-col-1">
              <h1>Ruta generada</h1>

              <span className="ruta-info">
                <GiPositionMarker />
                Distancia total: {(intervalDistance.reduce((acc: any, val: any) => acc + val, 0)).toFixed(2)} km</span>
            </div>
            <img src="/enk-logo.png" alt="logo enkbike" className="ruta-logo" />
          </div>


          <div className="ruta-map-wrapper">
            <div ref={mapRef} className="ruta-map" />

            <div className="ruta-overlay">
              <div className="ruta-overlay-item">
                <LocationIcon />
                <span>Puntos de ruta</span>
              </div>

              <div className="ruta-overlay-item">
                <RouteIcon />
                <span>Ruta</span>
              </div>
            </div>
          </div>
        </div>
        <div className="ruta-cards">
          <div className="ruta-cards-inner">
            <CardList
              currentSequence={currentSequence}
              intervalDistance={intervalDistance} />
          </div>
        </div>

      </div>
    </body >
  );
};
